export default __webpack_public_path__ + "static/media/v1.f2a36430.png";